import {all, call, put, takeLatest} from "redux-saga/effects";
import {
  setIncidentMitreTactics,
  setIncidentMitreTacticsFailure,
  setIncidentMitreTacticsSuccess
} from "store/features/mitreSlice";
import {fetchIncidentMitreTactics} from "api/incidentDetail";

export function* setIncidentMitreTacticsSaga(action) {
  try {
    const {id} = action.payload;
    const response = yield call(fetchIncidentMitreTactics, id);
    yield put(setIncidentMitreTacticsSuccess(response));
  } catch (error) {
    console.error(error);
    yield put(setIncidentMitreTacticsFailure(error));
  }
}

export default function* mitreSagas() {
  yield all([takeLatest(setIncidentMitreTactics, setIncidentMitreTacticsSaga)]);
}
